module.exports = __webpack_public_path__ + "static/img/guidebook.040440e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/guidebook.png
// module id = J8vZ
// module chunks = 4